import { Routes, Route } from 'react-router-dom';
import Intro from './pages/Home';
import Content from './pages/Contents';
import Comment from './pages/Comment';
import IssueDetail from './components/IssueDetail';
import Sidebar from './components/Sidebar';
import { BrowserRouter } from 'react-router-dom';
import { allIssues } from './data/issues';

function App() {
  return (
    <div className="app-layout">
      <Sidebar />
      {/* 3. 실제 콘텐츠가 바뀔 영역 */}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Intro allIssues={allIssues}/>} />
          <Route path="/content/:id" element={<Content />} />
          <Route path="/comment/:id" element={<Comment />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
